module.exports = __webpack_public_path__ + "static/media/gift06_en.dbfc629f.png";